import RegionPagesES from '@/services/RegionPagesES';

export const initRegionPages = ({ commit, getters, dispatch }, force) => {
    if (!getters.initialized || getters.isExpired() || force) {
        return dispatch('fetchRegionPages')
            .then(() => commit('SET_INITIALIZED', true))
            .then(() => dispatch('refreshExpirationDate'));
    }
}

export const refreshExpirationDate = ({ commit }) => {
    commit('SET_EXPIRATION_DATE')
}

export const fetchRegionPages = ({ commit }, payload) => {
    commit('SET_LOADING', true);
    return RegionPagesES.getRegionPages()
        .then(response => response.data)
        .then(data => commit('SET_REGION_PAGES', RegionPagesES.mapSource(data)))
        .finally(() => commit('SET_LOADING', false));
}
